import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { open: { type: Boolean, default: true } }

  declare openValue: boolean

  toggle (): void {
    this.openValue = !this.openValue
    this.element.querySelectorAll<Element>('[data-controller~="toggle"]').forEach(el => {
      const toggle = this.application.getControllerForElementAndIdentifier(el, 'toggle') as { show: () => void, hide: () => void } | null
      if (toggle !== null) this.openValue ? toggle.show() : toggle.hide()
    })
  }
}
